<template>
  <b-modal
    v-model="localVisible"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    content-class="bg-white"
    dialog-class="full-export-confirm-modal"
  >
    <template #modal-header>
      <div class="d-flex align-items-center">
        <b-icon icon="check-square" class="full-export-confirm-modal__icon mr-2" />
        <h5 class="mb-0 font-weight-bold text-uppercase">Full Data Export</h5>
      </div>
    </template>

    <p>
      Selecting this option will include the cumulative claims position for the latest
      reporting periods for all active and inactive BDX submitted through the platform.
    </p>

    <p class="mb-0">
      If you require a custom report or BDX submission to the market, do not use this function.
    </p>

    <template #modal-footer>
      <b-button class="btn-grey" @click="dismiss">Dismiss</b-button>
      <b-button class="btn-teal ml-2" @click="cont">Continue</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'SaveReportWizardFullExportConfirmModal',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    localVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    cont() {
      this.$emit('input', false)
      this.$emit('continue')
    },
    dismiss() {
      this.$emit('input', false)
      this.$emit('dismiss')
    },
    onSelectFilters() {
      this.$emit('input', false)
      this.$emit('select-filters')
    }
  }
}
</script>

<style lang="scss">
.full-export-confirm-modal {
  margin-top: 20vh;

  .modal-content { background-color: #fff; }
  .modal-header  { padding: 1rem 1.4rem; background-color: #fff; border-bottom: 1px solid #dee2e6; }
  .modal-body    { padding: 1rem 1.4rem; background-color: #fff; }
  .modal-footer  { padding: 0.75rem 1.4rem; background-color: #fff; }

  &__icon {
    font-size: 1.1rem;
    color: #1c4a50;
  }
}

.btn-grey {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #fff;

  &:hover {
    background-color: #5a6268;
    border-color: #545b62;
    color: #fff;
  }
}

.btn-teal {
  background-color: #1c4a50;
  border-color: #1c4a50;
  color: #fff;

  &:hover,
  &:focus {
    background-color: #163b40;
    border-color: #163b40;
    color: #fff;
  }
}
</style>
